
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";
import { successAlert } from "../../../components/alert/defaultAlert";
import axiosInstance from "../../../../services/AxiosInstance";

const RestockNew = () => {

    const { t } = useTranslation();
    const [type, setType] = useState("IN");
    const [resetForm, setResetForm] = useState(false);

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        qty: Yup.number()
            .typeError(t('validation.required.qty'))
            .positive(t('validation.required.qty'))
            .required(t('validation.required.qty')),
        products: Yup.array().required(t('validation.required.product')).min(1, t('validation.required.product')).nullable(),
        branch: Yup.object().required(t('validation.required.branch')).nullable(),
        description: Yup.string().optional()
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            products: null,
            qty: '',
            description: ''
        },
        validationSchema: formSchema,
        onSubmit: (values) => {
            let productIds = [];
            for (let i = 0; i < values.products.length; i++) {
                productIds.push(values.products[i].value);
            }

            let payload = {
                productIds: productIds,
                qty: values.qty,
                type: type,
                branchId: values.branch.value,
                description: values.description
            }

            // Aciona a api
            axiosInstance.post(Api.stock_control.restock + "/multi", payload)
                .then(() => {
                    successAlert(t('message.operation_successfully'), () => {
                        onReset();
                    });
                })
                .catch(error => ApiError(error))
                .finally(() => {
                    // Deixa habilitado o botão de submit.
                    formik.setSubmitting(false);
                });
        },
    });

    const onReset = () => {
        formik.resetForm();

        // Muda toda o valor para forçar o useEffect no form.
        // Ao detectar mudança no valor do resetForm, ele limpa os itens do pedido.
        setResetForm(!resetForm);

        setType("IN");
    }

    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('stock_control')}
                childMenu={t('restock')}
                activeMenu={t('new')}
                child={
                    <Form
                        formik={formik}
                        setType={setType}
                        type={type}
                        resetForm={resetForm} />}
                path={"/stock-control/movements"}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.stock_control.restock.route}
            />
        </>
    );
}

export default RestockNew;
